"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InsightSection = void 0;

var _react = _interopRequireDefault(require("react"));

var _Grid = require("@cx/couturier/Grid");

var _Button = _interopRequireDefault(require("@cx/couturier/Button"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Articles = require("./Articles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InsightSection = function InsightSection(_ref) {
  var title = _ref.title,
      articles = _ref.articles,
      className = _ref.className,
      ctaDescription = _ref.ctaDescription,
      ctaTitle = _ref.ctaTitle,
      onCtaAction = _ref.onCtaAction,
      onSceneChange = _ref.onSceneChange,
      onClick = _ref.onClick,
      onMouseOver = _ref.onMouseOver;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "InsightSection ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_Grid.Container, null, title && /*#__PURE__*/_react.default.createElement(_Grid.Row, {
    align: "center",
    className: "title-row"
  }, /*#__PURE__*/_react.default.createElement(_Grid.Col, {
    small: 12,
    medium: 8
  }, /*#__PURE__*/_react.default.createElement("h1", null, title))), /*#__PURE__*/_react.default.createElement(_Grid.Row, {
    align: "center",
    className: "carousel-row"
  }, /*#__PURE__*/_react.default.createElement(_Articles.Articles, {
    className: className && "".concat(className, "-articles"),
    articles: articles,
    onSceneChange: onSceneChange,
    onClick: onClick,
    onMouseOver: onMouseOver
  })), ctaDescription && /*#__PURE__*/_react.default.createElement(_Grid.Row, {
    align: "center",
    className: "ctaDescription-row"
  }, /*#__PURE__*/_react.default.createElement(_Grid.Col, {
    small: 12,
    className: "ctaDescription"
  }, ctaDescription)), ctaTitle && onCtaAction && /*#__PURE__*/_react.default.createElement(_Grid.Row, {
    align: "center",
    className: "cta"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onCtaAction
  }, ctaTitle))));
};

exports.InsightSection = InsightSection;
InsightSection.propTypes = {
  articles: _propTypes.default.array.isRequired,
  className: _propTypes.default.string,
  title: _propTypes.default.node,
  ctaDescription: _propTypes.default.node,
  ctaTitle: _propTypes.default.node,
  onCtaAction: _propTypes.default.func,
  onSceneChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onMouseOver: _propTypes.default.func
};